import {
  FETCH_ALL_BLOGS,
  FETCH_BLOG,
  CREATE_BLOG,
  UPDATE_BLOG,
  DELETE_BLOG,
} from "../types";

const initialState = {
  loading: false,
  message: null,
  data: [],
};

export const blogsReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_ALL_BLOGS}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${FETCH_ALL_BLOGS}_FULFILLED`:
      const result = action.payload.data ? action.payload.data.results : {};
      return {
        ...state,
        loading: false,
        data: result,
        message: action.payload.data?.message || "",
      };

    case `${FETCH_ALL_BLOGS}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const blogReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_BLOG}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${FETCH_BLOG}_FULFILLED`:
      const result = action.payload.data.results
        ? action.payload.data.results
        : {};
      return {
        ...state,
        loading: false,
        data: result,
        message: action.payload.data.message,
      };

    case `${FETCH_BLOG}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const createBlogReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${CREATE_BLOG}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${CREATE_BLOG}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload.results ? action.payload.results : {},
        message: action.payload.message,
      };

    case `${CREATE_BLOG}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const updateBlogReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${UPDATE_BLOG}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${UPDATE_BLOG}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload.results ? action.payload.results : {},
        message: action.payload.message,
        error: action.payload.error,
      };

    case `${UPDATE_BLOG}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const deleteBlogReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${DELETE_BLOG}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${DELETE_BLOG}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload ? action.payload.message : {},
        message: action.payload.message,
        error: action.payload.error,
      };

    case `${DELETE_BLOG}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};
